var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaginationDoubleArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.779 10.5a3.33 3.33 0 0 1-.973 2.36l-5.445 5.444a.67.67 0 0 1-.946-.946l5.445-5.445a2 2 0 0 0 0-2.826L9.415 3.642a.67.67 0 0 1 .946-.946l5.445 5.445a3.334 3.334 0 0 1 .973 2.359z",
    fill: "#A2A1AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.56 10.5a3.333 3.333 0 0 1-.973 2.36l-5.445 5.444a.67.67 0 1 1-.946-.946l5.445-5.445a2 2 0 0 0 0-2.826L4.196 3.642a.67.67 0 0 1 .946-.946l5.445 5.445a3.33 3.33 0 0 1 .973 2.359z",
    fill: "#A2A1AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationDoubleArrowRight);
export default __webpack_public_path__ + "static/media/pagination-double-arrow-right.5569122e731fca28eb9762d2dc4a5df8.svg";
export { ForwardRef as ReactComponent };